import React, { createContext, useContext } from "react";

const EntitlementRepositoryContext = createContext(null);

export const EntitlementRepositoryProvider = ({ repository, children }) => (
  <EntitlementRepositoryContext.Provider value={repository || null}>
    {children}
  </EntitlementRepositoryContext.Provider>
);

export const useEntitlementRepository = () =>
  useContext(EntitlementRepositoryContext);

export default EntitlementRepositoryContext;
